import type { ShiftFormManagerDashboard } from "../../../shared/shift-production-form/contracts";
import type { ColumnMeasure } from "./analysis-columns";

type Props = {
  entries: ShiftFormManagerDashboard["analytics"]["wasteEntries"];
  selected: Extract<ColumnMeasure, { kind: "WASTE" }>;
  onChange: (value: string) => void;
};
export function ProductionAnalysisWastePicker({ entries, selected, onChange }: Props) {
  const types = [...new Map(entries.map(entry => [entry.key, entry.label])).entries()];
  if (!types.some(([key]) => key === selected.key)) types.push([selected.key, selected.label]);
  const units = [...new Set([...entries.filter(entry => entry.key === selected.key).map(entry => entry.unit), selected.unit])];
  const selectType = (key: Props["selected"]["key"]) => {
    if (key === selected.key) return;
    const target = entries.find(entry => entry.key === key && entry.unit === selected.unit) ?? entries.find(entry => entry.key === key);
    if (target) onChange(`${target.key}:${target.unit}`);
  };
  return <div className="pa-waste-picker" role="group" aria-label="Fire türü ve birimi">
    <div className="pa-waste-types" role="group" aria-label="Fire türü">{types.map(([key, label]) => <button key={key} type="button" title={label} aria-pressed={selected.key === key} onClick={() => selectType(key)}>{label.replace(/ Fire$/u, "")}</button>)}</div>
    <div className="pa-output-units" role="group" aria-label="Fire birimi">{units.map(unit => <button key={unit} type="button" aria-pressed={selected.unit === unit} onClick={() => onChange(`${selected.key}:${unit}`)}>{unit}</button>)}</div>
  </div>;
}
